module.exports = __webpack_public_path__ + "img/img6.d5691e39.png";